import { useHistory } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import Botao from '../Botao/Botao';
import Modal from '../Modal/Modal';
import { BotaoContainer, ModalContainerDelete, ModalTitle, Paragraph, SpinnerConatainer } from './styles';

interface updateModalProps {
  isModalOpen: boolean;
  onCloseModal: any;
}

const ModalRecoveryApproved = (props: updateModalProps): any => {
  const { isModalOpen, onCloseModal } = props;
  const history = useHistory();
  return (
    <Modal
      isOpen={isModalOpen}
      width={420}
      onClose={onCloseModal}
    >
      <>
        <ModalContainerDelete>
          <ModalTitle>Sucesso!</ModalTitle>
          <SpinnerConatainer>
            <CheckIcon htmlColor='green' style={{ fontSize: 50 }} />
          </SpinnerConatainer>
          <Paragraph>Foi enviado um email com sua nova senha.</Paragraph>
          <Paragraph>Acesse com ela para redefinir.</Paragraph>
          <BotaoContainer>
            <Botao
              tamanho="medio"
              tipo='salvar'
              className="btn"
              onClick={() =>
                setTimeout(() => {
                  history.push('/')
                }, 500)
              }
            >
              Continuar
            </Botao>
          </BotaoContainer>
        </ModalContainerDelete>
      </>
    </Modal>
  );
};

export default ModalRecoveryApproved;
